import "./App.css";

//Pages
import Main from "./pages/Main";

function App() {
  return (
    <div className=" bg-main">
      <Main />
    </div>
  );
}

export default App;
